export default {
    Search: 'Suche',
    'No results found.': 'Keine Ergebnisse gefunden.',
    cancel: 'beenden'
};



//////////////////
// WEBPACK FOOTER
// /Users/emmanuelpiguet/Documents/Web/Local/icmc/app/public/wp-content/themes/icmc/node_modules/mmenu-js/dist/addons/searchfield/translations/de.js
// module id = 83
// module chunks = 0